<script setup lang="ts">
import { selectionActions } from "@/action/selectionActions";
import type { SelectionScope } from "@/action/selectionActions";
import { actionMapWith } from "@/components/action/action";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import MenuList from "@/components/ui/MenuList/MenuList.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import MenuListItems from "@/components/ui/MenuList/MenuListItems.vue";
import { injectStrict } from "@/utils/vue";

const dropdown = injectStrict(dropdownKey);
const actions = actionMapWith<[SelectionScope]>("selection")(selectionActions, {
  click: () => dropdown.close(),
});
</script>

<template>
  <MenuList role="dialog">
    <MenuListItems>
      <MenuListItem v-bind="actions.alignHorizontal" />
      <MenuListItem v-bind="actions.distributeHorizontal" />
      <MenuListItem v-bind="actions.alignVertical" />
      <MenuListItem v-bind="actions.distributeVertical" />
      <MenuListItem v-bind="actions.lineup" />
      <MenuListItem v-bind="actions.arrange" />
      <MenuListItem v-bind="actions.stack" />
    </MenuListItems>
  </MenuList>
</template>
